import { apiService } from './api.service';

export interface AdminCaseListItem {
  caseId: string;
  requestId: string;
  userEmail: string | null;
  createdAt: string | null;
  updatedAt: string | null;
  planType: string;
  paymentStatus: string;
  caseStatus: string;
  reviewStatus: string;
  sessionStatus: string | null;
}

export interface AdminCaseDetail {
  caseId: string;
  user: {
    uid: string | null;
    email: string | null;
    displayName: string | null;
  };
  planType: string;
  paymentStatus: string;
  caseStatus: string;
  reviewRequest: Record<string, unknown> | null;
  ticket: Record<string, unknown> | null;
  answers: Record<string, unknown>;
  appealLetter: string | Record<string, unknown> | null;
  evidence: Array<{
    evidenceId: string;
    category: string | null;
    status: string | null;
    summary: string | null;
    confidence: number | null;
    file: Record<string, unknown> | null;
    extracted: Record<string, unknown> | null;
    confirmation: Record<string, unknown> | null;
    createdAt: string | null;
    updatedAt: string | null;
  }>;
  metadata: Record<string, unknown>;
}

export const adminService = {
  async getCases(): Promise<AdminCaseListItem[]> {
    const response = await apiService.getAdminCases();
    return (response as any)?.cases || [];
  },

  async getCaseDetail(caseId: string): Promise<AdminCaseDetail> {
    const response = await apiService.getAdminCaseDetail(caseId);
    return response as unknown as AdminCaseDetail;
  },

  async updateCaseStatus(caseId: string, status: 'in_review' | 'completed'): Promise<void> {
    await apiService.updateAdminCaseStatus(caseId, { status });
  },
};

export default adminService;
